import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { DialogData } from './dialog.interface'
import { SafeDomPipe } from '@app/v2/shared/pipes/safe-dom.pipe'

@Component({
  selector: 'ngx-dialog',
  styleUrls: ['./dialog.component.scss'],
  templateUrl: './dialog.component.html',
  imports: [MatDialogModule, CommonModule, SafeDomPipe]
})
export class DialogComponent {
  /** Injectable dialog reference */
  protected readonly dialogRef: MatDialogRef<DialogComponent> = inject(MatDialogRef<DialogComponent>)
  /** Injectable dialog data */
  protected readonly data: DialogData = inject(MAT_DIALOG_DATA)

  get safeMessageText(): string {
    return this.data?.messageText || ''
  }

  proceed(confirm: 'confirm' | 'confirmTwo') {
    this.dialogRef.close(confirm)
  }
}
